export const getOrdinalSuffix = (number) => {
  if (number > 3 && number < 21) return "th";

  const lastDigit = number % 10;
  switch (lastDigit) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
